import { createApp } from 'vue'
import App from './App.vue'
import './styles/base.css'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'

console.log(`Env: ${process.env.NODE_ENV}`)

createApp(App).use(store).use(router).use(VueAxios, axios).mount('#app')
